import { render, staticRenderFns } from "./feather_icon.vue?vue&type=template&id=55b54dda&"
import script from "./feather_icon.vue?vue&type=script&lang=js&"
export * from "./feather_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports